'use client';

import { clsx } from 'clsx';
import { ReactNode } from 'react';
import * as styles from './status-pill.css';

export type StatusPillTone = keyof typeof styles.tone;

export interface StatusPillProps {
  tone: StatusPillTone;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
  'data-id'?: string;
}

/**
 * Small rounded pill used inside the hero ("Ready in ~15 min" / "Confirmed" / "On its way")
 * and as the ETA chip on the delivery state.
 */
export const StatusPill = ({ tone, icon, children, className, ...rest }: StatusPillProps) => (
  <span className={clsx(styles.pill, styles.tone[tone], className)} {...rest}>
    {icon ? <span className={styles.icon}>{icon}</span> : null}
    <span>{children}</span>
  </span>
);
